__turbopack_context__.v({
  "actions": "ulwdBG_actions",
  "body": "ulwdBG_body",
  "cardSlot": "ulwdBG_cardSlot",
  "cards": "ulwdBG_cards",
  "group": "ulwdBG_group",
  "header": "ulwdBG_header",
  "headerContainer": "ulwdBG_headerContainer",
  "heading": "ulwdBG_heading",
  "intro": "ulwdBG_intro",
  "offerBadge": "ulwdBG_offerBadge",
  "outline": "ulwdBG_outline",
  "panel": "ulwdBG_panel",
  "paragraph": "ulwdBG_paragraph",
  "photo": "ulwdBG_photo",
  "photoBox": "ulwdBG_photoBox",
  "photoDesktop": "ulwdBG_photoDesktop",
  "photoMobile": "ulwdBG_photoMobile",
  "primary": "ulwdBG_primary",
  "reveal": "ulwdBG_reveal",
  "row": "ulwdBG_row",
});
